<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
  >
    <path
      d="M0 0h32v32H0z"
      fill="none"
    />
    <path
      fill="currentColor"
      d="M17 3a1 1 0 1 0-2 0v1h-4.75A3.25 3.25 0 0 0 7 7.25v5.5A3.25 3.25 0 0 0 10.25 16h10.665l.505-1.58a2.16 2.16 0 0 1 .8-1a2.14 2.14 0 0 1 1.25-.4a2.16 2.16 0 0 1 1.428.542q.101-.391.102-.812v-5.5A3.25 3.25 0 0 0 21.75 4H17zM8.25 19h8.496c-.16.307-.245.65-.246 1a2.17 2.17 0 0 0 1.45 2l1.71.56c.29.093.554.254.77.47c0 .036.04.072.084.111a.5.5 0 0 1 .076.079a1.8 1.8 0 0 1 .31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08a1.9 1.9 0 0 0-.25.9q0 .088.008.175a8 8 0 0 1-.521.377C22.08 29.302 19.366 30 16 30s-6.08-.698-7.987-1.968C6.077 26.742 5 24.871 5 22.7v-.45A3.25 3.25 0 0 1 8.25 19m4.25-7.25a1.75 1.75 0 1 1 0-3.5a1.75 1.75 0 0 1 0 3.5M21.25 10a1.75 1.75 0 1 1-3.5 0a1.75 1.75 0 0 1 3.5 0m.238 12.011a3.5 3.5 0 0 1 .837 1.363l.548 1.683a.664.664 0 0 0 1.254 0l.548-1.683a3.47 3.47 0 0 1 2.197-2.196l1.684-.547a.665.665 0 0 0 0-1.254l-.034-.008l-1.683-.547a3.47 3.47 0 0 1-2.198-2.196l-.547-1.683a.664.664 0 0 0-1.255 0l-.547 1.683l-.014.042a3.47 3.47 0 0 1-2.15 2.154l-1.684.547a.665.665 0 0 0 0 1.254l1.684.546c.513.171.979.46 1.36.842m9.333 4.847l.918.298l.019.004a.362.362 0 0 1 0 .684l-.919.298a1.9 1.9 0 0 0-1.198 1.198l-.299.918a.363.363 0 0 1-.684 0l-.299-.918a1.89 1.89 0 0 0-1.198-1.202l-.919-.298a.362.362 0 0 1 0-.684l.919-.298a1.9 1.9 0 0 0 1.18-1.198l.299-.918a.363.363 0 0 1 .684 0l.298.918a1.89 1.89 0 0 0 1.199 1.198"
    />
  </svg>
</template>

<script>
  // NOTE: was difficult to make this a functional component... merging classes was yuck
  export default {
    name: 'AiIcon',
  };
</script>
